// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3zStS","noInteraction":"EventWrapper_noInteraction__3TmhA"};